import React, { ChangeEvent } from 'react';

import { observer } from 'mobx-react-lite';
import { action } from 'mobx';
import styled from '@emotion/styled';
import { ColorResult } from 'react-color';

import Campaign from 'models/Campaign';
import Switch from '@vromo/ui/components/Switch';
import { TextArea } from '@vromo/ui/components/Input';
import { Upload } from '@vromo/models';
import ColorPicker from './ColorPicker';
import ImageEditor from '../ImageEditor';
import { qaLabelCampaigns } from './../../../../../../../common-qa-labels/campaigns';

const LOCALE_ENABLED = 'Enabled';
const LOCALE_CUSTOM_CSS = 'Custom CSS';
const LOCALE_BACKGROUND = 'Background';
const LOCALE_ACCENT = 'Accent';
const LOCALE_COLORS = 'Colors';
const LOCALE_MAP_ICON = 'Map icon';

export const Color = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 4px;
`;

interface Props {
    campaign: Campaign;
    onChangeMapIcon: (file?: File) => void;
}

export default observer<Props>(function Theme({ campaign, onChangeMapIcon }) {
    return (
        <div>
            <label>{LOCALE_ENABLED}</label>
            <Switch
                testId={qaLabelCampaigns.editModal.enableThemeBtn}
                style={{ margin: '0 16px' }}
                checked={campaign.theme?.enabled}
                onChange={action((enabled) => (campaign.theme!.enabled = enabled as boolean))}
            />

            <h4>{LOCALE_MAP_ICON}</h4>

            <ImageEditor
                url={campaign.theme!.icon?.url || ''}
                onChange={({ url, file }) => {
                    onChangeMapIcon(file);
                    campaign.theme!.icon = file ? new Upload(url) : null;
                }}
            />

            <h4>{LOCALE_COLORS}</h4>

            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Color>
                    <ColorPicker
                        color={campaign.theme!.background}
                        onChange={action((c: ColorResult) => {
                            campaign.theme!.background = c.hex.toUpperCase();
                            campaign.theme!.header = c.hex.toUpperCase();
                        })}
                    />
                    <p>{LOCALE_BACKGROUND}</p>
                </Color>
                <Color>
                    <ColorPicker
                        color={campaign.theme!.accent}
                        onChange={action(
                            (c: ColorResult) => (campaign.theme!.accent = c.hex.toUpperCase())
                        )}
                    />
                    <p>{LOCALE_ACCENT}</p>
                </Color>
            </div>

            <label>{LOCALE_CUSTOM_CSS}</label>
            <TextArea
                style={{ display: 'block' }}
                value={campaign.theme!.customCss}
                onChange={action(
                    (e: ChangeEvent<HTMLTextAreaElement>) =>
                        (campaign.theme!.customCss = e.target.value)
                )}
            />
        </div>
    );
});
